var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { DiagramConsts } from '../diagram-consts';
var ResizeMultipleTool = /** @class */ (function (_super) {
    __extends(ResizeMultipleTool, _super);
    /**
     * @constructor
     * @extends ResizingTool
     * @class
     * A custom tool for resizing multiple objects at once.
     */
    function ResizeMultipleTool() {
        var _this = _super.call(this) || this;
        _this.name = 'ResizeMultiple';
        return _this;
    }
    /**
     * Overrides ResizingTool.resize to resize all selected objects to the same size.
     * @this {ResizeMultipleTool}
     * @param {Rect} newr the intended new rectangular bounds for each Part's {@link Part#resizeObject}.
     */
    ResizeMultipleTool.prototype.resize = function (newr) {
        var _this = this;
        var diagram = this.diagram;
        if (diagram == null || null == this.adornedObject) {
            return;
        }
        var oldWidth = this.adornedObject.naturalBounds.width > 0 ? this.adornedObject.naturalBounds.width : newr.width;
        var oldHeight = this.adornedObject.naturalBounds.height > 0 ? this.adornedObject.naturalBounds.height : newr.height;
        var scaleWidth = newr.width / oldWidth;
        var scaleHeight = newr.height / oldHeight;
        diagram.selection.each(function (part) {
            if (part instanceof go.Link || part instanceof go.Group) {
                return;
            } // only Nodes and simple Parts
            var obj = part.resizeObject;
            // calculate new location
            var pos = part.position.copy();
            var angle = obj.getDocumentAngle();
            var sc = obj.getDocumentScale();
            // 切换固定点（不是左上角的时候） 拉右下角缩放后 再撤销，会出现先撤销了大小，撤第二次才撤位置，原因是position没有改变
            //  这里先加后减，相当于位置没有偏移，但是position改变过了
            // 能解决上述问题
            pos.x += 0.00001;
            var radAngle = Math.PI * angle / 180;
            var angleCos = Math.cos(radAngle);
            var angleSin = Math.sin(radAngle);
            var deltaWidth = newr.width - _this.adornedObject.naturalBounds.width;
            var deltaHeight = newr.height - _this.adornedObject.naturalBounds.height;
            var angleBottom = (angle > 0 && angle < 180) ? 1 : 0;
            var angleTop = (angle > 180 && angle < 360) ? 1 : 0;
            var angleRight = (angle > 90 && angle < 270) ? 1 : 0;
            pos.x += sc * ((newr.x + deltaWidth * angleRight) * angleCos - (newr.y + deltaHeight * angleBottom) * angleSin);
            pos.y += sc * ((newr.x + deltaWidth * angleTop) * angleSin + (newr.y + deltaHeight * angleRight) * angleCos);
            var category = part.data.category;
            var desiredWidth = obj.naturalBounds.width * scaleWidth;
            var desiredHeight = obj.naturalBounds.height * scaleHeight;
            if (category === DiagramConsts.elements.weatherKey) {
                return;
            }
            if (part.resizable) {
                if (_.includes([DiagramConsts.elements.meterKey, DiagramConsts.elements.ringGraphKey], category)) {
                    // 仪表及环形图：宽高一致
                    obj.desiredSize = new go.Size(desiredWidth, desiredWidth);
                }
                else if (DiagramConsts.elements.sectorKey !== category && DiagramConsts.elements.tableKey !== category) {
                    obj.desiredSize = new go.Size(desiredWidth, desiredHeight);
                }
                if (DiagramConsts.elements.tableKey === category) {
                    var widths = _.cloneDeep(part.data.widths);
                    var heights = _.cloneDeep(part.data.heights);
                    var widthSum = widths.reduce(function (prev, cur, index, array) {
                        return prev + cur;
                    });
                    var heightSum = heights.reduce(function (prev, cur, index, array) {
                        return prev + cur;
                    });
                    for (var i = 0; i < widths.length; i++) {
                        var width = widths[i] / widthSum * (desiredWidth - widths.length + 1);
                        widths[i] = width > 0.1 ? width : 0.1;
                    }
                    for (var i = 0; i < heights.length; i++) {
                        var height = heights[i] / heightSum * (desiredHeight - heights.length + 1);
                        heights[i] = height > 0.1 ? height : 0.1;
                    }
                    _this.setDataProperty(part.data, 'widths', widths);
                    _this.setDataProperty(part.data, 'heights', heights);
                    // 加上分割线宽度
                    obj.desiredSize = new go.Size(desiredWidth, desiredHeight);
                }
                part.position = pos;
                part.position.x -= 0.00001;
            }
        });
        if (this.diagram.lastInput.up) {
            this.diagram.rebuildParts();
        }
    };
    ResizeMultipleTool.prototype.setDataProperty = function (dataArray, type, value) {
        this.diagram.model.setDataProperty(dataArray, type, value);
    };
    return ResizeMultipleTool;
}(go.ResizingTool));
export { ResizeMultipleTool };
